<template>
  <div>
    <v-row>
      <v-col cols="12">
        <DadataOrgField
          v-model="v.name.$model"
          :errorMessages="getValidationErrorText(v.name)"
          label="Наименование, указанное в ЕГРЮЛ"
          outlined
          :suggestions="suggestions"
          field="name"          
          @suggest="onSelect"           
        />
      </v-col>

      <v-col cols="4">
        <DadataOrgField
          v-model="v.ogrn.$model"
          :errorMessages="getValidationErrorText(v.ogrn)"
          mask="#############"
          label="ОГРН"
          outlined
          :disabled="true"
          :suggestions="suggestions"
          field="ogrn"          
          @suggest="onSelect"           
        />
      </v-col>
      <v-col cols="4">
        <DadataOrgField
          v-model="v.inn.$model"
          :errorMessages="getValidationErrorText(v.inn)"
          mask="##########"
          label="ИНН"
          outlined
          :disabled="true"
          :suggestions="suggestions"
          field="inn"          
          @suggest="onSelect"           
        />
      </v-col>
      <v-col cols="4">
        <v-text-field
          v-model="v.kpp.$model"
          :errorMessages="getValidationErrorText(v.kpp)"
          v-mask="KPP"
          label="КПП"
          outlined
        />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { maxLength, minLength, required } from 'vuelidate/lib/validators';

import {getValidationErrorText, EMOJI, INN_ROD, OGRN, KPP} from '@/utils/validate';
import DadataOrgField from '@/components/base/DadataOrgField';

export const organizationModel = {
  name: '',
  ogrn: '',
  inn: '',
  kpp: '',
};

export const organizationValidation = {
  name: {
    required,
    maxLength: maxLength(1000),
    EMOJI,
  },
  ogrn: {
    required,
    minLength: minLength(13),
    OGRN,
  },
  inn: {
    required,
    minLength: minLength(10),
    INN: INN_ROD,
  },
  kpp: {
    required,
    minLength: minLength(9),
    KPP,
  },
};

export default {
  name: 'Organization',
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  components: {
    DadataOrgField,
  },  
  data: () => ({
    suggestions: [],
    getValidationErrorText,
  }),
  methods: {
    onSelect: function (item) {
      this.suggestions = [item];
      this.v.name.$model = item.name;
      this.v.inn.$model = item.inn;
      this.v.ogrn.$model = item.ogrn;
      this.v.kpp.$model = item.kpp;      
    }
  }  
};
</script>
